import { render, staticRenderFns } from "./ImportUpload.vue?vue&type=template&id=cf1c87ba"
import script from "./ImportUpload.vue?vue&type=script&lang=js"
export * from "./ImportUpload.vue?vue&type=script&lang=js"
import style0 from "./ImportUpload.vue?vue&type=style&index=0&id=cf1c87ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports